import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-hovered-disabled-input',
    templateUrl: './hovered-disabled-input.component.html',
    styleUrls: ['./hovered-disabled-input.component.scss']
})
export class HoveredDisabledInputComponent implements OnInit {

    @Input() textValue: string;
    @Input() textAlign: 'right' | 'left' = 'right';


    constructor() {
    }

    ngOnInit() {
    }

    public isRightAligned(): boolean {
        return this.textAlign === 'right';
    }

}
